<template>
    <main class="browser-open-guide">
        <svg class="guide-arrow" viewBox="0 0 180 200" aria-hidden="true">
            <path class="guide-arrow-curve" d="M15 190 C12 162 35 149 51 160 C68 172 56 188 42 181 C25 172 31 147 52 137 C75 125 92 137 89 152 C86 164 70 164 67 153 C63 136 85 118 104 99 C129 75 153 42 169 6"/>
            <path d="M157 13 L169 6 L170 20"/>
        </svg>
        <section class="guide-content">
            <div class="guide-icon">
                <a-icon type="compass"/>
            </div>
            <h1>请在浏览器中打开</h1>
            <p>点击右上角 <strong>···</strong></p>
            <p>选择“在浏览器打开”继续前往{{ platformName }}</p>
            <span v-if="redirectError" class="guide-error">{{ redirectError }}</span>
        </section>
    </main>
</template>

<script>
export default {
    name: 'BrowserOpenGuide',
    props: {
        platform: {type: String, default: ''}
    },
    data() {
        return {
            redirectError: ''
        };
    },
    computed: {
        platformName() {
            return this.platform || String(this.$route.query.platform || '').trim() || '目标应用';
        }
    },
    mounted() {
        document.title = '请在浏览器中打开';
        this.continueInBrowser();
    },
    methods: {
        continueInBrowser() {
            // 微信等内置浏览器只展示引导页，系统浏览器打开后再继续原跳转。
            if (this.isRestrictedInAppBrowser()) return;
            const targetUrl = String(this.$route.query.target || '').trim();
            if (!targetUrl) {
                this.redirectError = '跳转地址已失效，请返回后重试';
                return;
            }
            window.location.replace(targetUrl);
        },
        isRestrictedInAppBrowser() {
            return /MicroMessenger|QQ\/|Weibo|DingTalk|AlipayClient/i.test(
                navigator.userAgent || ''
            );
        }
    }
};
</script>

<style scoped>
.browser-open-guide {
    position: relative;
    min-height: 100vh;
    min-height: 100dvh;
    overflow: hidden;
    color: #1f2937;
    background: #fff;
}

.guide-arrow {
    position: absolute;
    top: calc(8px + env(safe-area-inset-top));
    right: 8px;
    width: 180px;
    height: min(200px, 28vh);
    fill: none;
    stroke: #c5cad1;
    stroke-width: 2.5;
    stroke-linecap: round;
    stroke-linejoin: round;
}

.guide-arrow-curve {
    stroke-dasharray: 3 5;
}

.guide-content {
    display: flex;
    min-height: 100vh;
    min-height: 100dvh;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    box-sizing: border-box;
    padding: 32px 28px 12vh;
    text-align: center;
}

.guide-icon {
    display: flex;
    width: 64px;
    height: 64px;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    border-radius: 20px;
    color: #2878df;
    font-size: 31px;
    background: #eef5ff;
}

.guide-content h1 {
    margin: 0 0 18px;
    color: #111827;
    font-size: 23px;
    font-weight: 600;
}

.guide-content p {
    margin: 3px 0;
    color: #6b7280;
    font-size: 15px;
    line-height: 1.7;
}

.guide-content p strong {
    color: #374151;
    letter-spacing: 2px;
}

.guide-error {
    margin-top: 18px;
    color: #e5484d;
    font-size: 13px;
}
</style>
